const LIST_ITEM_HEIGHT = 64;

export { LIST_ITEM_HEIGHT };
